import IService from '../IService';

export default IService.extend({
  stopEntityXHR: function () {
    if (app.xhrExpected(this.entityXHR)) {
      this.entityXHR.abort();
      this.entityXHR = null;
    }
  },

  get: function () {
    const deferred = new $.Deferred();

    this.stopEntityXHR();
    this.entityXHR = $.ajax({
      url: app.apiUrl('/api/v1/wallpapers?limit=30'),
      type: 'GET',
      error: function (xhr) {
        if (xhr.status === 401) {
          deferred.reject({ loggedOut: true });
        } else {
          deferred.reject();
        }
      },

      dataType: 'json',
      success: function (response) {
        if (_.isArray(response.wallpapers)) {
          deferred.resolve(response.wallpapers.slice(0, 30));
        }
      },
    }).always(() => {
      this.entityXHR = null;
    });

    return Promise.resolve(deferred.promise());
  },
  post: function (data) {
    const deferred = new $.Deferred();
    delete data._source;

    this.stopEntityXHR();
    this.entityXHR = $.ajax({
      url: app.apiUrl('/api/v1/wallpapers'),
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      error: function (xhr) {
        if (xhr.status === 401) {
          deferred.reject({ loggedOut: true });
        } else {
          deferred.reject();
        }
      },

      success: function (response) {
        deferred.resolve(response.id);
      },
    }).always(() => {
      this.entityXHR = null;
    });

    return Promise.resolve(deferred.promise());
  },

  touch: function (id) {
    const deferred = new $.Deferred();

    this.stopEntityXHR();
    this.entityXHR = $.ajax({
      url: app.apiUrl('/api/v1/wallpapers/' + id + '/touch'),
      type: 'PUT',
      dataType: 'json',
      error: function (xhr) {
        if (xhr.status === 401) {
          deferred.reject({ loggedOut: true });
        } else {
          deferred.reject();
        }
      },

      success: function (/* response*/) {
        deferred.resolve();
      },
    }).always(() => {
      this.entityXHR = null;
    });

    return Promise.resolve(deferred.promise());
  },

  delete: function (id) {
    const deferred = new $.Deferred();

    this.stopEntityXHR();
    this.entityXHR = $.ajax({
      url: app.apiUrl('/api/v1/wallpapers/' + id),
      type: 'DELETE',
      dataType: 'json',
      error: function (xhr) {
        if (xhr.status === 401) {
          deferred.reject({ loggedOut: true });
        } else {
          deferred.reject();
        }
      },

      success: function (/* response*/) {
        deferred.resolve();
      },
    }).always(() => {
      this.entityXHR = null;
    });

    return Promise.resolve(deferred.promise());
  },
});
